import { getUnseenReceivedSharesCount } from "@ando/core";
import { useQuery } from "@tanstack/react-query";

/**
 * Received shares the user has never opened in-app — the number on the
 * Condivisioni rail icon. Same cadence as the notification bell so the two
 * signals never disagree for long. Leaf module (no barrel imports): the rail
 * lives in ``features/chat`` and must not pull the share barrel → chat cycle.
 */
export const UNSEEN_SHARES_QUERY_KEY = ["chat-shares", "received", "unseen-count"] as const;
const POLL_MS = 60_000;

export function useUnseenSharesCount(): number {
  const query = useQuery({
    queryKey: UNSEEN_SHARES_QUERY_KEY,
    queryFn: getUnseenReceivedSharesCount,
    staleTime: POLL_MS,
    refetchInterval: POLL_MS,
    retry: 1,
  });
  return query.data?.unseen_count ?? 0;
}
